import React, { useEffect, useState } from 'react';
// import { Helmet } from 'react-helmet-async';
import $ from 'jquery';

import {
    // BusinessListLayout,
    // CategoriesListLayout,
    Footer,
    // Header
} from '../layouts';


import {
    Goto,
    HeroSm,
    NavBar,
    Spinner
} from '../components';
import axios from 'axios';




const BusinessDetails = () => {

    const [loadPage, setLoadPage] = useState(true);
    const [spinColor, setSpinColor] = useState("success");

    const [business, setBusiness] = useState(0);
    // const clrs = ["primary", "body", "success", "info", "danger", "warning", "info", "success", "light", "dark"];


    const getBusiness = async () => {
        const { data } = await axios.get(`https://abn.happynessarl.com/api/v1/company/${window.location.pathname.split('/')[2]}`, {});

        if (data) {
            setLoadPage(false);
        }
        setBusiness(data);
        return data;
    }

    useEffect(() => {
        getBusiness();

        return () => {
        };
    }, []);

    return <>

        {
            loadPage
                ? <>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                        width: '100%',
                        position: 'fixed',
                        left: 0,
                        top: 0,
                    }}>
                        <Spinner grow color={spinColor} size={5} />

                    </div>

                </>
                : <GroupHome business={business} />
        }

        {/*<Helmet>*/}
        {/*    /!* <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap" rel="stylesheet" /> *!/*/}
        {/*    <title>Business OverView</title>*/}
        {/*    <link rel="stylesheet" href="../assets/css/bootstrap/icons/bootstrap-icons.css" />*/}
        {/*    <link rel="stylesheet" href="../assets/css/hs/mega-menu/mega-menu.min.css" />*/}
        {/*    <link rel="stylesheet" href="../assets/css/_theme.css" />*/}

        {/*    <script defer asyn src="../assets/js/bootstrap/bootstrap.bundle.min.js"></script>*/}
        {/*    <script defer asyn src="../assets/js/hs/mega-menu/mega-menu.min.js"></script>*/}
        {/*    <script defer asyn src="../assets/js/hs/go-to/goto.min.js"></script>*/}
        {/*    <script defer asyn src="../assets/js/hs/sticky-block/sticky-block.min.js"></script>*/}
        {/*    <script defer asyn src="../assets/js/hs/nav-scroller/nav-scroller.min.js"></script>*/}
        {/*    <script defer asyn src="../assets/js/leaflet/leaflet.js"></script>*/}

        {/*    <script defer asyn src="../assets/js/theme.min.js"></script>*/}

        {/*</Helmet>*/}
    </>
}

export default BusinessDetails;



const GroupHome = ({ business }) => {

    const { data } = business;

    useEffect(() => {
        const script = `
        new HSMegaMenu('.js-mega-menu', {
            desktop: {
                position: 'left'
            }
        })
  
        HSBsValidation.init('.js-validate', {
            onSubmit: data => {
                data.event.preventDefault()
                alert('Submited')
            }
        })
        HSBsDropdown.init()
        new HSGoTo('.js-go-to')
  
        new HSStickyBlock('.js-sticky-block', {
          targetSelector: document.getElementById('header').classList.contains('navbar-fixed') ? '#header' : null
        })
  
        new HsNavScroller('.js-nav-scroller')
        const leaflet = HSCore.components.HSLeaflet.init(document.getElementById('map'))
        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
          id: 'mapbox/light-v9'
        }).addTo(leaflet)
        
        `;






        $('body').append(`<script className="homescript">${script}</script>`)

        return () => {
            $('.homescript').remove();
        };
    }, []);

    return <>
        {/* <Header /> */}
        <NavBar transparent sub />

        <HeroSm title={data.name} sub={data.category} />

        <Tre />
        <Goto />
        <Footer sub />
    </>
};



const Tre = () => {

    return <>

        <main id="content" role="main">
            <div className="container content-space-t-3 pb-3">
                <div className="row align-items-lg-center">
                    <div className="col-lg mb-2 mb-lg-0">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a href="#">For Sale</a></li>
                                <li className="breadcrumb-item"><a href="#">England</a></li>
                                <li className="breadcrumb-item"><a href="#">London</a></li>
                                <li className="breadcrumb-item"><a href="#">Studio</a></li>
                                <li className="breadcrumb-item active" aria-current="page">470 Lucy Forks, Patriciafurt, YC7B
                                </li>
                            </ol>
                        </nav>
                    </div>

                    <div className="col-lg-auto">
                        <a className="btn btn-sm btn-ghost-secondary" href="#/">
                            <i className="bi-heart me-2"></i> Save
                        </a>

                        <a className="btn btn-sm btn-ghost-secondary" href="#/">
                            <i className="bi-share-fill me-2"></i> Share
                        </a>
                    </div>
                </div>
            </div>

            <div className="container mb-5">
                <div className="rounded-2 overflow-hidden">
                    <div className="row gx-2">
                        <div className="col-md-8">
                            <a className="d-block position-relative" href="../assets/img/1920x1080/img27.jpg"
                                data-fslightbox="propertyOverviewGallery">
                                <img className="img-fluid w-100" src="../assets/img/900x455/img1.jpg" alt="Description_Image" />

                                <div className="position-absolute bottom-0 end-0 mb-3 me-3">
                                    <span className="d-md-none btn btn-sm btn-light">
                                        <i className="bi-arrows-fullscreen me-2"></i> View photos
                                    </span>
                                </div>
                            </a>
                        </div>

                        <div className="col-md-4 d-none d-md-inline-block">
                            <a className="d-block mb-2" href="../assets/img/1920x1080/img11.jpg"
                                data-fslightbox="propertyOverviewGallery">
                                <img className="img-fluid w-100" src="../assets/img/450x225/img1.jpg" alt="Description_Image" />
                            </a>

                            <a className="d-block position-relative" href="../assets/img/1920x1080/img14.jpg"
                                data-fslightbox="propertyOverviewGallery">
                                <img className="img-fluid w-100" src="../assets/img/450x225/img2.jpg" alt="Description_Image" />

                                <div className="position-absolute bottom-0 end-0 mb-3 me-3">
                                    <span className="d-none d-md-inline-block btn btn-sm btn-light">
                                        <i className="bi-arrows-fullscreen me-2"></i> View photos
                                    </span>
                                </div>
                            </a>

                            <a className="d-none" href="../assets/img/1920x1080/img24.jpg"
                                data-fslightbox="propertyOverviewGallery"></a>
                            <a className="d-none" href="../assets/img/1920x1080/img20.jpg"
                                data-fslightbox="propertyOverviewGallery"></a>
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-end mt-2">
                    <span className="small text-dark fw-semi-bold">Published:</span>
                    <span className="small ms-1">December 27, 2018</span>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-8 mb-9 mb-lg-0">
                        <div className="row justify-content-lg-between mb-7">
                            <div className="col-12 col-sm-6 mb-5 mb-sm-0">
                                <h1 className="h2 mb-0">470 Lucy Forks</h1>
                                <span className="d-block text-dark mb-3">Patriciafurt, YC7B, London, England</span>

                                <ul className="list-inline list-separator font-size-1 text-body">
                                    <li className="list-inline-item">
                                        <i className="fas fa-bed text-muted me-1"></i> 3 bed
                                    </li>
                                    <li className="list-inline-item">
                                        <i className="fas fa-bath text-muted me-1"></i> 2 bath
                                    </li>
                                    <li className="list-inline-item">
                                        <i className="fas fa-ruler-combined text-muted me-1"></i> 1,428 sqft
                                    </li>
                                </ul>
                            </div>

                            <div className="col-sm-6 column-divider-sm">
                                <div className="pl-md-4">
                                    <h2 className="mb-0">&#163;8,999,000</h2>
                                    <span className="d-block text-dark mb-3">Est. Mortgage &#163;2,562/mo</span>
                                    <a href="#">Get Pre-Qualified</a>
                                </div>
                            </div>
                        </div>

                        <div className="js-nav-scroller hs-nav-scroller-horizontal">
                            <span className="hs-nav-scroller-arrow-prev" style={{ display: "none" }}>
                                <a className="hs-nav-scroller-arrow-link" href="#/">
                                    <i className="bi-chevron-left"></i>
                                </a>
                            </span>

                            <span className="hs-nav-scroller-arrow-next" style={{ display: "none" }}>
                                <a className="hs-nav-scroller-arrow-link" href="#/">
                                    <i className="bi-chevron-right"></i>
                                </a>
                            </span>

                            <ul className="nav nav-segment nav-fill mb-7" id="propertyOverviewNavTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <a className="nav-link active" href="#propertyOverviewNavOne"
                                        id="propertyOverviewNavOne-tab" data-bs-toggle="tab"
                                        data-bs-target="#propertyOverviewNavOne" role="tab"
                                        aria-controls="propertyOverviewNavOne" aria-selected="true"
                                        style={{ minWidth: "7rem" }}>Details</a>
                                </li>

                                <li className="nav-item" role="presentation">
                                    <a className="nav-link" href="#propertyOverviewNavTwo" id="propertyOverviewNavTwo-tab"
                                        data-bs-toggle="tab" data-bs-target="#propertyOverviewNavTwo" role="tab"
                                        aria-controls="propertyOverviewNavTwo" aria-selected="false"
                                        style={{ minWidth: "7rem" }}>Floorplan</a>
                                </li>

                                <li className="nav-item" role="presentation">
                                    <a className="nav-link" href="#propertyOverviewNavThree" id="propertyOverviewNavThree-tab"
                                        data-bs-toggle="tab" data-bs-target="#propertyOverviewNavThree" role="tab"
                                        aria-controls="propertyOverviewNavThree" aria-selected="false"
                                        style={{ minWidth: "7rem" }}>Map</a>
                                </li>

                                <li className="nav-item" role="presentation">
                                    <a className="nav-link" href="#propertyOverviewNavThree" id="propertyOverviewNavFour-tab"
                                        data-bs-toggle="tab" data-bs-target="#propertyOverviewNavFour" role="tab"
                                        aria-controls="propertyOverviewNavFour" aria-selected="false"
                                        style={{ minWidth: "7rem" }}>Market stats</a>
                                </li>
                            </ul>
                        </div>

                        <div className="tab-content">
                            <div className="tab-pane fade show active" id="propertyOverviewNavOne" role="tabpanel"
                                aria-labelledby="propertyOverviewNavOne-tab">
                                <div className="mb-4">
                                    <h4>Home details</h4>
                                </div>

                                <div className="row justify-content-md-between">
                                    <div className="col-md-5">
                                        <dl className="row">
                                            <dt className="col-6">Property ID:</dt>
                                            <dd className="col-6">HG328e91UA</dd>

                                            <dt className="col-6">Property type:</dt>
                                            <dd className="col-6">House</dd>

                                            <dt className="col-6">Year built:</dt>
                                            <dd className="col-6">2015</dd>
                                        </dl>
                                    </div>

                                    <div className="col-md-5">
                                        <dl className="row">
                                            <dt className="col-6">Lot size:</dt>
                                            <dd className="col-6">1,428 sq.m.</dd>

                                            <dt className="col-6">Rooms:</dt>
                                            <dd className="col-6">12</dd>

                                            <dt className="col-6">Parking:</dt>
                                            <dd className="col-6">2</dd>
                                        </dl>
                                    </div>
                                </div>

                                <div className="border-top border-bottom py-4 mt-4 mb-7">
                                    <div className="row col-sm-divider">
                                        <div className="col-sm-6 text-sm-end mb-2 mb-sm-0">
                                            <div className="pe-md-4">
                                                <span>Last 30 days:</span>
                                                <span className="text-dark fw-semi-bold">920 page views</span>
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="ps-md-4">
                                                <span>Since listed:</span>
                                                <span className="text-dark fw-semi-bold">471 page views</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <h4>Description</h4>
                                </div>

                                <p>This extremely spacious two/three bedroom duplex apartment occupies a desirable position to
                                    the South-West of Harrogate's town centre and offers a huge amount of scope to update and
                                    re-model to suit the individual including a large eaves storage room ripe for conversion
                                    into a second bathroom.</p>

                                <p>Accessed via a communal hall up to the first floor, the apartment opens into a split level
                                    hall. To the front elevation there is a lovely, light and airy lounge with far reaching
                                    views towards the town centre and countryside beyond. Adjoining there is a well proportioned
                                    double bedroom with a fitted wardrobe.</p>

                                <div className="collapse" id="propertyOverviewDescriptionViewMoreCollapse">
                                    <div className="mb-4">
                                        <h4>Directions</h4>
                                    </div>

                                    <p>Proceed up the Otley Road from the Prince Of Wales roundabout and through the traffic
                                        lights with the turning into Harlow Moor Road. Continue ahead where the property can be
                                        found on the left hand side.</p>

                                    <div className="mb-4">
                                        <h4>Strictly by appointment through Front House</h4>
                                    </div>

                                    <p>You may download, store and use the material for your own personal use and research. You
                                        may not republish, retransmit, redistribute or otherwise make the material available to
                                        any party or make the same available on any website, online service or bulletin board of
                                        your own or of any other party or make the same available in hard copy or in any other
                                        media without the website owner's express prior written consent. The website owner's
                                        copyright must remain on all reproductions of material taken from this website.</p>
                                </div>

                                <a className="link link-collapse" data-bs-toggle="collapse"
                                    href="#propertyOverviewDescriptionViewMoreCollapse" role="button" aria-expanded="false"
                                    aria-controls="propertyOverviewDescriptionViewMoreCollapse">
                                    <span className="link-collapse-default">View More</span>
                                    <span className="link-collapse-active">View Less</span>
                                </a>

                                <hr className="my-6" />

                                <div className="mb-4">
                                    <h4>Accessibility</h4>
                                </div>

                                <div className="row">
                                    <div className="col-sm-6">
                                        <ul className="list-unstyled list-py-1 mb-0">
                                            <li className="d-flex align-items-center">
                                                <h6 className="mb-0">Location</h6>

                                                <div className="d-flex gap-1 ms-auto">
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                </div>
                                            </li>

                                            <li className="d-flex align-items-center">
                                                <h6 className="mb-0">Area safety</h6>

                                                <div className="d-flex gap-1 ms-auto">
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star-half.svg" alt="Review rating"
                                                        width="16" />
                                                </div>
                                            </li>

                                            <li className="d-flex align-items-center">
                                                <h6 className="mb-0">Close to schools</h6>

                                                <div className="d-flex gap-1 ms-auto">
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star-half.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star-muted.svg" alt="Review rating"
                                                        width="16" />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="col-sm-6">
                                        <ul className="list-unstyled list-py-1 mb-0">
                                            <li className="d-flex align-items-center">
                                                <h6 className="mb-0">Low cost</h6>

                                                <div className="d-flex gap-1 ms-auto">
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                </div>
                                            </li>

                                            <li className="d-flex align-items-center">
                                                <h6 className="mb-0">Built around</h6>

                                                <div className="d-flex gap-1 ms-auto">
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star-muted.svg" alt="Review rating"
                                                        width="16" />
                                                </div>
                                            </li>

                                            <li className="d-flex align-items-center">
                                                <h6 className="mb-0">Value</h6>

                                                <div className="d-flex gap-1 ms-auto">
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star-muted.svg" alt="Review rating"
                                                        width="16" />
                                                    <img src="../assets/img/svg/illustrations/star-muted.svg" alt="Review rating"
                                                        width="16" />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <hr className="my-6" />

                                <h4 className="mb-1">Estimated running costs</h4>
                                <p className="small">Based on available 3rd party data</p>

                                <div className="row">
                                    <div className="col-md-6">
                                        <span className="h1">&#163;810</span>
                                        <p>Approximate costs per month</p>
                                    </div>

                                    <div className="col-md-6">
                                        <dl className="row">
                                            <dt className="col-6">
                                                <i className="bi-bank2 me-2"></i> Mortgage
                                            </dt>
                                            <dd className="col-6 text-end">&#163;700 p/m</dd>

                                            <dt className="col-6">
                                                <i className="bi-lightning-charge-fill me-2"></i> Energy
                                            </dt>
                                            <dd className="col-6 text-end">from &#163;72 p/m</dd>

                                            <dt className="col-6">
                                                <i className="bi-droplet-half me-2"></i> Water
                                            </dt>
                                            <dd className="col-6 text-end">
                                                from &#163;38 p/m
                                            </dd>

                                            <dt className="col-6 text-dark">
                                                <i className="bi-shield-shaded me-2"></i> Home insurance
                                            </dt>
                                            <dd className="col-6 text-end">not known</dd>
                                        </dl>
                                    </div>
                                </div>
                            </div>

                            <div className="tab-pane fade" id="propertyOverviewNavTwo" role="tabpanel"
                                aria-labelledby="propertyOverviewNavTwo-tab">
                                <a href="../assets/img/others/img1.png" data-fslightbox="propertyOverviewFloorplan">
                                    <img className="img-fluid" src="../assets/img/others/img1.png" alt="Description_Image" />
                                </a>

                                <small className="form-text">Image source from <a className="link-sm"
                                    href="https://floorplanner.com/" target="_blank">floorplanner.com</a></small>
                            </div>

                            <div className="tab-pane fade" id="propertyOverviewNavThree" role="tabpanel"
                                aria-labelledby="propertyOverviewNavThree-tab">
                                <div id="map" className="h-380rem" data-hs-leaflet-options='{
                     "map": {
                       "scrollWheelZoom": false,
                       "coords": [37.4040344, -122.0289704]
                     },
                     "marker": [
                       {
                         "coords": [37.4040344, -122.0289704],
                         "icon": {
                           "iconUrl": ".../assets/svg/components/map-pin.svg",
                           "iconSize": [50, 45]
                         },
                         "popup": {
                           "text": "153 Williamson Plaza, Maggieberg",
                           "title": "Address"
                         }
                       }
                     ]
                    }'></div>
                            </div>

                            <div className="tab-pane fade" id="propertyOverviewNavFour" role="tabpanel"
                                aria-labelledby="propertyOverviewNavFour-tab">
                                <div className="mb-5">
                                    <h5>Sale activity</h5>
                                    <p>Average estimated value for a flat in HG2:</p>

                                    <h3 className="text-primary mb-0">&#163;271,401</h3>
                                    <i className="bi-arrow-down-right text-danger"></i>
                                    <span>&#163;7,710 (-2.762%)</span>
                                    <span className="text-muted small ms-1">Over the last 12 months</span>
                                </div>

                                <div className="mb-5">
                                    <h5>In the last 12 months</h5>

                                    <div className="row justify-content-sm-between">
                                        <div className="col-sm-6">
                                            <span className="d-block">Average sale price</span>
                                            <h3 className="text-primary mb-0">&#163;267,606</h3>
                                        </div>

                                        <div className="col-sm-6">
                                            <span className="d-block">Properties sold</span>
                                            <h3 className="text-primary mb-0">51</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr className="my-6" />

                        <div className="mb-4">
                            <h4>Listing agents</h4>
                        </div>

                        <div className="row">
                            <div className="col-sm-6 col-md-5 mb-4 mb-sm-0">
                                <div className="d-flex">
                                    <div className="flex-shrink-0">
                                        <img className="avatar avatar-lg avatar-circle" src="../assets/img/160x160/img6.jpg"
                                            alt="Description_Image" />
                                    </div>

                                    <div className="flex-grow-1 ms-3">
                                        <h4 className="mb-1">
                                            <a className="text-dark" href="#">O'Brian Cox</a>
                                        </h4>

                                        <span className="d-block small mb-1">
                                            <i className="bi-telephone-fill me-1"></i> +1 416 346 8780
                                        </span>

                                        <a className="link" href="#">Contact agent</a>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-5">
                                <div className="d-flex">
                                    <div className="flex-shrink-0">
                                        <span className="avatar avatar-lg avatar-soft-danger avatar-circle">
                                            <span className="avatar-initials">KP</span>
                                        </span>
                                    </div>

                                    <div className="flex-grow-1 ms-3">
                                        <h4 className="mb-1">
                                            <a className="text-dark" href="#">Keystones Property</a>
                                        </h4>

                                        <span className="d-block small mb-1">
                                            <i className="bi-telephone-fill me-1"></i> +1 822 012 3281
                                        </span>

                                        <a className="link" href="#">Contact agent</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div id="stickyBlockStartPoint">
                            <div className="js-sticky-block" data-hs-sticky-block-options='{
                 "parentSelector": "#stickyBlockStartPoint",
                 "breakpoint": "lg",
                 "startPoint": "#stickyBlockStartPoint",
                 "endPoint": "#stickyBlockEndPoint",
                 "stickyOffsetTop": 24,
                 "stickyOffsetBottom": 0
               }'>
                                <div className="card card-bordered">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center mb-4">
                                            <div className="flex-shrink-0">
                                                <img className="avatar avatar-circle" src="../assets/img/160x160/img3.jpg"
                                                    alt="Description_Image" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h4 className="card-title">Ask me for more information</h4>
                                            </div>
                                        </div>

                                        <form>
                                            <select className="form-select mb-2">
                                                <option selected disabled>Tell me more about this property</option>
                                                <option value="aboutProperty1">Request a showing</option>
                                                <option value="aboutProperty2">Request neighborhood information</option>
                                                <option value="aboutProperty3">Request recent area sales</option>
                                            </select>

                                            <div className="mb-2">
                                                <label htmlFor="fullNamePropertyOverviewContactForm"
                                                    className="form-label visually-hidden">Full Name</label>
                                                <input type="text" className="form-control"
                                                    id="fullNamePropertyOverviewContactForm" placeholder="Full Name"
                                                    aria-label="Full Name" />
                                            </div>

                                            <div className="mb-2">
                                                <label htmlFor="emailPropertyOverviewContactForm"
                                                    className="form-label visually-hidden">Email</label>
                                                <input type="email" className="form-control"
                                                    id="emailPropertyOverviewContactForm" placeholder="Email"
                                                    aria-label="Email" />
                                            </div>

                                            <div className="mb-2">
                                                <label htmlFor="phoneNumberPropertyOverviewContactForm"
                                                    className="form-label visually-hidden">Phone number</label>
                                                <input type="tel" className="form-control"
                                                    id="phoneNumberPropertyOverviewContactForm" placeholder="+x(xxx)xxx-xx-xx"
                                                    aria-label="+x(xxx)xxx-xx-xx" />
                                            </div>

                                            <div className="mb-2">
                                                <label htmlFor="questionPropertyOverviewContactForm"
                                                    className="form-label visually-hidden">Property question</label>
                                                <textarea className="form-control" id="questionPropertyOverviewContactForm"
                                                    placeholder="I would like more information about ..."
                                                    aria-label="I would like more information about ..." rows="4"></textarea>
                                            </div>

                                            <div className="d-grid">
                                                <button type="button" className="btn btn-primary">Request info</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="stickyBlockEndPoint"></div>

                <hr className="my-6" />

                <div className="card card-bordered">
                    <div className="card-body">
                        <h4 className="card-title mb-4">Payment calculator</h4>

                        <div className="mb-4">
                            <span className="h4">&#163;37,469</span>
                            <span className="h6">monthly.</span>
                            <span className="ms-3">In association with:</span>
                        </div>

                        <div className="row mb-2 mb-lg-0">
                            <div className="col-lg-7 mb-2 mb-lg-0">
                                <form className="row">
                                    <div className="col-sm-6 mb-3">
                                        <label htmlFor="properyPricePaymentCalculator" className="form-label">Property price</label>

                                        <div className="input-group input-group-merge">
                                            <span className="input-group-prepend input-group-text"><i
                                                className="bi-currency-pound"></i></span>
                                            <input type="text" className="form-control" id="properyPricePaymentCalculator"
                                                value="8,999,000" disabled />
                                        </div>
                                    </div>

                                    <div className="col-sm-6 mb-3">
                                        <label htmlFor="depositPaymentCalculator" className="form-label">Deposit</label>

                                        <div className="input-group input-group-merge">
                                            <span className="input-group-prepend input-group-text"><i
                                                className="bi-currency-pound"></i></span>
                                            <input type="text" className="form-control" id="depositPaymentCalculator"
                                                value="1,799,800" />
                                        </div>
                                    </div>

                                    <div className="col-sm-6 mb-3">
                                        <label htmlFor="interestRatePaymentCalculator" className="form-label">Interest rate</label>

                                        <div className="input-group input-group-merge">
                                            <span className="input-group-prepend input-group-text">%</span>
                                            <input type="text" className="form-control" id="interestRatePaymentCalculator"
                                                value="3.5" />
                                        </div>
                                    </div>

                                    <div className="col-sm-6 mb-3">
                                        <label htmlFor="amortizationPaymentCalculator" className="form-label">Amortization</label>

                                        <select className="form-select" id="amortizationPaymentCalculator">
                                            <option value="amortization1">30 years</option>
                                            <option selected>25 years</option>
                                            <option value="amortization2">20 years</option>
                                            <option value="amortization3">15 years</option>
                                            <option value="amortization4">10 years</option>
                                        </select>
                                    </div>
                                </form>
                            </div>

                            <div className="col-lg-5">
                                <div className="progress mb-3">
                                    <div className="progress-bar" role="progressbar" style={{ width: "60%" }} aria-valuenow="15"
                                        aria-valuemin="0" aria-valuemax="100"></div>
                                    <div className="progress-bar bg-success" role="progressbar" style={{ width: "30%" }}
                                        aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                                    <div className="progress-bar bg-info" role="progressbar" style={{ width: "10%" }}
                                        aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>

                                <ul className="list-unstyled list-py-1 mb-0">
                                    <li className="d-flex align-items-center">
                                        <i className="bi-circle text-primary me-2"></i>
                                        <span className="text-dark fw-semi-bold">Principal and Interest</span>
                                        <div className="ms-auto">
                                            <span>&#163;35,943 /mo</span>
                                        </div>
                                    </li>

                                    <li className="d-flex align-items-center">
                                        <i className="bi-circle text-success me-2"></i>
                                        <span className="text-dark fw-semi-bold">Property Taxes</span>
                                        <div className="ms-auto">
                                            <span>&#163;1,526 /mo</span>
                                        </div>
                                    </li>

                                    <li className="d-flex align-items-center">
                                        <i className="bi-circle text-info me-2"></i>
                                        <span className="text-dark fw-semi-bold">Yearly Condo Fees</span>
                                        <div className="ms-auto">
                                            <span>n/a</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <p className="card-text small">* These results are not provided by Front House and are only indicative
                            based
                            on a repayment mortgage product. Repayments will be subject to the product provided and your
                            circumstances.</p>
                    </div>
                </div>
            </div>

            <div className="container content-space-2">
                <div className="w-md-75 w-lg-50 mb-4">
                    <h3>Similar properties you may like</h3>
                </div>

                <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
                    <div className="swiper-slide">
                        <a className="card card-flush shadow-none" href="../demo-real-estate/property-overview.html">
                            <div className="card-pinned">
                                <img className="card-img" src="../assets/img/480x320/img23.jpg" alt="Description_Image" />

                                <div className="card-pinned-top-start">
                                    <span className="badge bg-success">New</span>
                                </div>
                            </div>

                            <div className="card-body">
                                <span className="card-subtitle text-body">For sale</span>

                                <div className="row align-items-center mb-3">
                                    <div className="col">
                                        <h4 className="card-title text-inherit">Borrett Close, London</h4>
                                    </div>

                                    <div className="col-auto">
                                        <h3 className="card-title text-primary">&#163;689,000</h3>
                                    </div>
                                </div>

                                <ul className="list-inline list-separator text-body small">
                                    <li className="list-inline-item">
                                        <span className="svg-icon svg-icon-xs svg-inline text-muted me-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 640 512">
                                                <path
                                                    d="M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z" />
                                            </svg>
                                        </span>
                                        3 bed
                                    </li>
                                    <li className="list-inline-item">
                                        <span className="svg-icon svg-icon-xs svg-inline text-muted me-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 512 512">
                                                <path
                                                    d="M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z" />
                                            </svg>
                                        </span>
                                        2 bath
                                    </li>
                                    <li className="list-inline-item">
                                        <i className="bi-rulers text-muted me-1"></i> 1,428 sqft
                                    </li>
                                </ul>
                            </div>
                        </a>
                    </div>

                    <div className="swiper-slide">
                        <a className="card card-flush shadow-none" href="../demo-real-estate/property-overview.html">
                            <div className="card-pinned">
                                <img className="card-img" src="../assets/img/480x320/img19.jpg" alt="Description_Image" />
                            </div>

                            <div className="card-body">
                                <span className="card-subtitle text-body">For sale</span>

                                <div className="row align-items-center mb-3">
                                    <div className="col">
                                        <h4 className="card-title text-inherit">The Drive, Ilford</h4>
                                    </div>

                                    <div className="col-auto">
                                        <h3 className="card-title text-primary">&#163;999,000</h3>
                                    </div>
                                </div>

                                <ul className="list-inline list-separator text-body small">
                                    <li className="list-inline-item">
                                        <span className="svg-icon svg-icon-xs svg-inline text-muted me-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 640 512">
                                                <path
                                                    d="M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z" />
                                            </svg>
                                        </span>
                                        2 bed
                                    </li>
                                    <li className="list-inline-item">
                                        <span className="svg-icon svg-icon-xs svg-inline text-muted me-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 512 512">
                                                <path
                                                    d="M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z" />
                                            </svg>
                                        </span>
                                        1 bath
                                    </li>
                                    <li className="list-inline-item">
                                        <i className="bi-rulers text-muted me-1"></i> 2,123 sqft
                                    </li>
                                </ul>
                            </div>
                        </a>
                    </div>

                    <div className="swiper-slide">
                        <a className="card card-flush shadow-none" href="../demo-real-estate/property-overview.html">
                            <div className="card-pinned">
                                <img className="card-img" src="../assets/img/480x320/img20.jpg" alt="Description_Image" />

                                <div className="card-pinned-top-start">
                                    <span className="badge bg-primary">New build</span>
                                </div>
                            </div>

                            <div className="card-body">
                                <span className="card-subtitle text-body">For sale</span>

                                <div className="row align-items-center mb-3">
                                    <div className="col">
                                        <h4 className="card-title text-inherit">Alderney House, Enfield</h4>
                                    </div>

                                    <div className="col-auto">
                                        <h3 className="card-title text-primary">&#163;725,000</h3>
                                    </div>
                                </div>

                                <ul className="list-inline list-separator text-body small">
                                    <li className="list-inline-item">
                                        <span className="svg-icon svg-icon-xs svg-inline text-muted me-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 640 512">
                                                <path
                                                    d="M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z" />
                                            </svg>
                                        </span>
                                        1 bed
                                    </li>
                                    <li className="list-inline-item">
                                        <span className="svg-icon svg-icon-xs svg-inline text-muted me-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 512 512">
                                                <path
                                                    d="M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z" />
                                            </svg>
                                        </span>
                                        1 bath
                                    </li>
                                    <li className="list-inline-item">
                                        <i className="bi-rulers text-muted me-1"></i> 1,791 sqft
                                    </li>
                                </ul>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </main>
    </>
};